import * as React from 'react';
import { MosaicKey } from 'react-mosaic-component/lib/types';
import { Route } from 'react-router-dom';

import { MosaicViewManager } from 'src/components/mosaic/MosaicViewManager';
import { MosaicCollapseOptionsById } from 'src/components/mosaic/types';
import {
  MosaicSplitOptions,
  MosaicSplitType,
  NestedMosaicParentInitial,
  ProjectTileId,
} from 'src/constants/mosaic';
import { ROUTE } from 'src/constants/routes';
import { ProjectWorkspace } from 'src/containers/Project/ProjectWorkspace';
import { ProjectMappingView } from 'src/containers/ProjectMapping/ProjectMappingView';
import { ProjectSidebar } from 'src/containers/ProjectSidebar/ProjectSidebar';
import {
  EditQuestionsContext,
  useEditQuestionsContextValue,
} from 'src/utils/voicebox/hooks/useEditQuestions';
import {
  EvaluateQuestionsContext,
  useEvaluateQuestionsContextValue,
} from 'src/utils/voicebox/hooks/useEvaluateQuestions';

const COLLAPSE_OPTIONS: MosaicCollapseOptionsById<ProjectTileId> = {
  [ProjectTileId.SIDEBAR]: {
    collapsible: true,
    collapsed: false,
    collapsedSize: 10,
    collapsedVisible: false,
  },
};

const INITIAL_VALUE: NestedMosaicParentInitial<ProjectTileId> = {
  first: ProjectTileId.SIDEBAR,
  second: ProjectTileId.VIEW,
};

const SPLIT_OPTIONS: MosaicSplitOptions = {
  firstMinSplitType: MosaicSplitType.NUMBER,
  firstMinSplitValue: 360,
  secondMinSplitType: MosaicSplitType.NUMBER,
  secondMinSplitValue: 600,
  initialSplitPercentage: 30,
};

export const ProjectRoutesSidebarWrapper: React.VFC<{ id: MosaicKey }> = () => (
  <>
    <Route exact path={ROUTE.PROJECT}>
      <ProjectSidebar />
    </Route>
    <Route exact path={ROUTE.PROJECT_MAPPING}>
      <ProjectSidebar />
    </Route>
  </>
);

export const ProjectRoutesViewWrapper: React.VFC<{ id: MosaicKey }> = () => (
  <>
    <Route exact path={ROUTE.PROJECT}>
      <ProjectWorkspace />
    </Route>
    <Route exact path={ROUTE.PROJECT_MAPPING}>
      <ProjectMappingView />
    </Route>
  </>
);

export const EditQuestionsWrapper: React.VFC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const editQuestionsContextValue = useEditQuestionsContextValue();
  return (
    <EditQuestionsContext.Provider value={editQuestionsContextValue}>
      {children}
    </EditQuestionsContext.Provider>
  );
};

export const EvaluateQuestionsWrapper: React.VFC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const evaluateQuestionsContextValue = useEvaluateQuestionsContextValue();
  return (
    <EvaluateQuestionsContext.Provider value={evaluateQuestionsContextValue}>
      {children}
    </EvaluateQuestionsContext.Provider>
  );
};

export const ProjectRoutes: React.VFC = () => (
  <MosaicViewManager
    collapseOptions={COLLAPSE_OPTIONS}
    containerClassName="sd-project-container"
    direction="row"
    initialValue={INITIAL_VALUE}
    splitOptions={SPLIT_OPTIONS}
  >
    <ProjectRoutesSidebarWrapper id={ProjectTileId.SIDEBAR} />
    <ProjectRoutesViewWrapper id={ProjectTileId.VIEW} />
  </MosaicViewManager>
);
